import gql from 'graphql-tag';

/**
 * Project fields the server computes from the whole project (`ProjectCalculationService`) and that
 * the block project-calculation shows. Selected by its mutation so the stored project stays
 * current after a block save.
 */
export const PROJECT_CALCULATION_RECOMPUTED_FIELDS = gql`
  fragment projectCalculationRecomputedFields on Project {
    id
    effectiveProjectLeaseCost
    effectiveTotalPlannedMaterialCost
    effectiveTotalLaborCost
    effectiveGeneralBusinessCosts
    effectiveGeneralBusinessCostsPercentage
    effectiveRiskAndProfit
    effectiveProfitMarginPercentage
  }
`;
